module.exports = __webpack_public_path__ + "img/dongji_ps_28.4370f828.jpg";